import axios from 'axios';

export const axiosInstance = axios.create({
    baseURL: `https://eyenyutitidulu2.website`
    // baseURL: `http://localhost:5202`
});
